import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components'
import { setEmailKnowYourRightsModal } from '../../actions/modals';
import { useSendKnowYourRightsEmail } from '../../hooks/editors';
import { showEmailKnowYourRightsSelector } from '../../selectors/modals';
import { emailSelector } from '../../selectors/entities';
import { Button } from './Common';
import { Modal } from './Modal';
import { Formik } from 'formik';
import { validateEmails } from '../../utils/validators';
import { TextField } from './FormFields';

const Title = styled.h3`
  font-weight: 800;
  font-size: 21px;
  margin-top: 10px;
`

const Text = styled.p`
  margin: 20px 0px;
`

export const EmailKnowYourRightsModal = () => {

  const showModal = useSelector(showEmailKnowYourRightsSelector);
  const dispatch = useDispatch();
  const onClose = () => dispatch(setEmailKnowYourRightsModal(false));
  const initEmail = useSelector(emailSelector)

  const [submit, submitting] = useSendKnowYourRightsEmail(onClose);

  if (!showModal) {
    return null;
  }

  return (
    <Formik
      validate={validateEmails}
      initialValues={{ email: initEmail || '' }}
      onSubmit={submit}>
      {({ handleSubmit, errors, touched, values, submitCount }) => {
        const getError = (name) => (touched[name] || submitCount >= 1) && errors[name];
        return (
          <Modal closeOnOuterClick={true} onClose={onClose} style={{ width: 'min(95%, 550px)' }}>
            <Title>Send Email</Title>
            <Text style={{marginBottom: '10px'}}>
              Enter the email that you'd like to send this page to.
            </Text>
            <TextField name="email" placeholder="example@gmail.com" error={getError("email")} />
            <Button isLoading={submitting} onClick={handleSubmit}>Send email</Button>
          </Modal>
        )}}
    </Formik>
  )
}